import { CFormSwitch } from '@coreui/react'
import React from 'react'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion'
import ArrowDown from '../../assets/arrow-down.svg'
import PaintBrushIcon from '../../assets/paint-brush-icon.svg'

const TemplateAccordion = ({ items, styles }) => {
  const getItemProps = (info) => {
    let itemsProps = {}
    if (info?.enableSwitch) {
      itemsProps = {
        dangerouslySetExpanded: info?.enableSwitch && info?.switchChecked,
      }
    }
    return itemsProps
  }

  return (
    <Accordion allowZeroExpanded className={`w-100 ${styles}`}>
      {items.map((info, index) => {
        const itemProps = getItemProps(info)
        return (
          <AccordionItem
            style={{
              pointerEvents:
                (info?.enableSwitch && !info?.switchChecked) || info?.disabled ? 'none' : 'auto',
              backgroundColor:
                (info?.enableSwitch && !info?.switchChecked) || info?.disabled
                  ? '#ececec'
                  : '#ffffff',
            }}
            className={`accordion-full ${info.itemStyle}`}
            key={index}
            {...itemProps}
          >
            <AccordionItemHeading className="">
              <AccordionItemButton
                className="accordion-box flex justify-content-between align-items-center"
                style={{
                  height: info.accordionHeight ? info.accordionHeight : '',
                  paddingRight: info.accordionPaddingRight ? info.accordionPaddingRight : '',
                }}
              >
                <div className=" flex flex-column">
                  <div className="d-flex align-items-center">
                    <span
                      style={{
                        fontSize: '20px',
                        fontWeight: 500,
                      }}
                    >
                      {info.title}
                    </span>
                    {info?.enableSwitch && (
                      <CFormSwitch
                        style={{ pointerEvents: 'initial' }}
                        className="mx-4"
                        label=""
                        id="accordionSwitch"
                        value={info?.switchChecked}
                        checked={info?.switchChecked}
                        valid={true}
                        onChange={(e) => info?.switchToggle(e)}
                      />
                    )}
                  </div>
                  <span style={{ fontSize: '11px', textAlign: 'left' }}>{info.description}</span>
                </div>
                <div
                  className={` flex justify-between items-center`}
                  style={{
                    width: info.enableColorPicker && info?.colorPickerFunction ? '76px' : 'auto',
                  }}
                >
                  {info.enableColorPicker && info?.colorPickerFunction ? (
                    <div
                      className={`h-[30px] w-[30px] flex justify-center items-center rounded-full overflow-hidden "`}
                    >
                      <img
                        src={PaintBrushIcon}
                        alt="PaintBrushIcon"
                        className="cursor-pointer w-full h-full"
                        onClick={info?.colorPickerFunction}
                      />
                    </div>
                  ) : null}
                  <div
                    style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
                    className={`h-[28.2px] w-[28.2px] rounded-full ${
                      (info?.enableSwitch && !info?.switchChecked) || info?.disabled
                        ? 'bg-[#7f817f]'
                        : 'bg-[#2172eb]'
                    } bg-[#2172eb] flex justify-center items-center cursor-pointer"`}
                  >
                    <AccordionItemState>
                      {({ expanded }) =>
                        expanded ? (
                          <img src={ArrowDown} alt="ArrowDown" className="rotateimg180" />
                        ) : (
                          <img src={ArrowDown} alt="ArrowDown" />
                        )
                      }
                    </AccordionItemState>
                  </div>
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>{info.children}</AccordionItemPanel>
          </AccordionItem>
        )
      })}
    </Accordion>
  )
}

export default TemplateAccordion
